import {
  RECEIVED_MATERIAL_USAGE_INFO, ERROR_ON_GETTING_MATERIAL_USAGE, START_FETCHING_MATERIAL_USAGE,
} from "../actions/types";

const initState = {
  loading: true,
  totalMaterialUsage: {},
  error: null
}

const materialUsageReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case START_FETCHING_MATERIAL_USAGE:
      return { ...state, loading: true }
    case RECEIVED_MATERIAL_USAGE_INFO:
      return { ...state, loading: false, ...payload }
    case ERROR_ON_GETTING_MATERIAL_USAGE:
      return { ...state, loading: false, ...payload }
    default:
      return state;
  }
}

export default materialUsageReducer;


// WEBPACK FOOTER //
// ./src/reducers/material-usage-reducer.js